import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

import { Placeholder, logo } from "../../Assets/images";

import {
  MenuHome,
  MenuSound,
  MenuMeditation,
  MenuMoon,
  MenuArticle,
  ArticlesIcon,
  StoreIcon,
  FindDoctorsIcon,
  CheckSymptomsIcon,
  MyMixes,
  crossIcon,
} from "../../Assets/svg";

import "./style.css";
import { Howl } from "howler";
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import BASEURL from "../../Config/global";
import QrCodeGenerator from "../../Components/MenuBar/QR-code";
import { hideUrlForAge, hideUrlForCountry } from "../../Util/global_functions";
import { useTranslation } from "react-i18next";

export const Menubar = (props) => {
  const primaryInformation = useRef(null)

  const location = useLocation();
  const { t } = useTranslation();

  const [informationData, setInformationData] = useState([]);
  const [showHideTray, setShowHideTray] = useState(false);
  const [desktopLogo, setDesktopLogo] = useState(null);
  const [headerLogo, setHeaderLogo] = useState(null);
  const [loader, setLoader] = useState(true);
  const [qrIsVisible, setQrIsVisible] = useState(false);
  const userCountry = JSON.parse(localStorage.getItem("user_country"));

  useEffect(() => {
    const sound = new Howl({
      src: [require(`./../../../src/Assets/audio/silent.mp3`)], // Update the path accordingly
      autoplay: true,
      html5: true,
      autoUnlock: true,
      preload: true,
      volume: 0,
      mute: true,
      autoSuspend: false,
    });

    // Play the sound
    sound.play();

    // Clean up
    return () => {
      sound.unload();
    };
  }, []);

  const menu = [
    {
      text: "Home",
      link: "/home",
      path: "home",
      icon: MenuHome,
    },
    {
      text: "Sounds & Music",
      link: "/sounds",
      path: "sounds",
      icon: MenuSound,
    },
    {
      text: "Relax Rest",
      link: "/relax-rest",
      path: "relaxation",
      icon: MenuMeditation,
    },
    {
      text: "Stories",
      link: "/stories",
      path: "stories",
      icon: MenuMoon,
    },
    {
      text: "AV Articles",
      link: "/articles",
      path: "articles",
      icon: MenuArticle,
    },
  ];

  useEffect(() => {
    async function informationTray() {
      setLoader(true);
      const currentUser = localStorage.getItem("user");
      const parsedUser = JSON.parse(currentUser);
      let endPoint;
      if (parsedUser.status === "coupon" || parsedUser.status === "coupon_sub_user" || parsedUser.status === "coupon_lead") {
        endPoint = "coupon-user";
      }
      if (parsedUser.status === "primary" || parsedUser.status === "sub_user" || parsedUser.status === "lead") {
        endPoint = "subscription-user";
      }
      try {
        const response = await axios.get(`${BASEURL}/api/user/${endPoint}/${parsedUser.id}/`);
        // console.log(response.data.data           
        if (response.data.error != true) {
          const data = response.data.data?.[0]
          setInformationData(data);
          if (data?.header_logo_info) {
            setHeaderLogo(data?.header_logo_info);
          } else {
            setHeaderLogo(Placeholder);
          }
          if (data?.desktop_logo) {
            setDesktopLogo(data?.desktop_logo);
          } else {
            setDesktopLogo(Placeholder);
          }
          setLoader(false);
          // console.log(response.data)
          // console.log(desktopLogo)
        } else {
          setLoader(false);
          console.log(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
    informationTray();
  }, [])


  if (primaryInformation?.current != null) {
    primaryInformation.current.innerHTML = ''
    const div = document.createElement("div");
    primaryInformation?.current.appendChild(div);
    if (informationData?.html_info_text) {
      div?.insertAdjacentHTML("beforebegin", informationData?.html_info_text)
    }
  }

  return (
    <div className={`menubar ${props?.menuClass}`}>
      <Link className="logo" to="/home">
        <img src={logo} alt="Logo" />
      </Link>
      <ul className="list-unstyled mb-0">
        <li className="menubar-li">
          <Link
            className={
              location.pathname.includes("home")
                ? "menuLink active"
                : "menuLink"
            }
            to={"/home"}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16.56 15.69"><defs>
            </defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path className="cls-1" d="M.44,7.41,7.12.92a1.64,1.64,0,0,1,2.32,0l6.68,6.49M14.38,5.86v8.52a.87.87,0,0,1-.87.87H11.76a.87.87,0,0,1-.87-.87V12.64a1.74,1.74,0,0,0-1.74-1.75H7.41a1.75,1.75,0,0,0-1.75,1.75v1.74a.87.87,0,0,1-.87.87H3.05a.87.87,0,0,1-.87-.87V5.86" /></g></g></svg>
            <span className="menuLinkText">{t("nav.home")}</span>
          </Link>
        </li>
        <li className="menubar-li">
          <Link
            className={
              location.pathname.includes("featured-mixes")
                ? "menuLink active"
                : "menuLink"
            }
            to={"/featured-mixes"}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g id="Featured Mix" clipPath="url(#clip0_53_45)">
                <path id="Square" d="M17.6952 0.513048C17.6585 0.504513 17.6204 0.5 17.5812 0.5H2.42941C1.46466 0.5 0.5 1.16765 0.5 2.18V17.83C0.5 18.843 1.45484 19.5 2.41882 19.5H17.5812C18.5481 19.5 19.5 18.8305 19.5 17.83V2.18C19.5 1.20698 18.619 0.562388 17.6952 0.513048Z" stroke="white" className="fmix-2" strokeMiterlimit="3.8637" strokeLinejoin="round" />
                <g id="Eq Lines">
                  <path id="Vector" d="M12.9045 6.65732C13.9095 6.65732 14.7337 5.83342 14.7337 4.82866C14.7337 3.8239 13.9095 3 12.9045 3C11.8995 3 11.0754 3.8239 11.0754 4.82866C11.0754 5.83342 11.8995 6.65732 12.9045 6.65732Z" fill="white" className="fmix-1" />
                  <path id="Vector_2" d="M4 4.82861H15.8794" stroke="white" className="fmix-2" strokeMiterlimit="10" strokeLinecap="round" />
                  <path id="Vector_3" d="M6.69346 11.6573C7.69849 11.6573 8.52261 10.8334 8.52261 9.82866C8.52261 8.8239 7.69849 8 6.69346 8C5.68844 8 4.86432 8.8239 4.86432 9.82866C4.86432 10.8334 5.68844 11.6573 6.69346 11.6573Z" fill="white" className="fmix-1" />
                  <path id="Vector_4" d="M4 9.82874H15.8794" stroke="white" className="fmix-2" strokeMiterlimit="10" strokeLinecap="round" />
                  <path id="Vector_5" d="M12.1709 16.9811C13.1759 16.9811 14 16.1572 14 15.1524C14 14.1476 13.1759 13.3237 12.1709 13.3237C11.1659 13.3237 10.3417 14.1476 10.3417 15.1524C10.3417 16.1572 11.1659 16.9811 12.1709 16.9811Z" fill="white" className="fmix-1" />
                  <path id="Vector_6" d="M4 15.1523H15.8794" stroke="white" className="fmix-2" strokeMiterlimit="10" strokeLinecap="round" />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_53_45">
                  <rect width="20" height="20" fill="white" className="fmix-1" />
                </clipPath>
              </defs>
            </svg>
            {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.29 25.31"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Sounds"><rect className="cls-mix1" x="7.63" y="8.63" width="21.16" height="16.18" /><path className="cls-mix2" d="M18.21,13.8a3,3,0,0,1,2.57-1.19,2.83,2.83,0,0,1,1.94,1.71c.69,1.68-.66,3.77-3.32,6.12a1.85,1.85,0,0,1-2.42,0c-2.65-2.35-4-4.41-3.28-6.08a2.88,2.88,0,0,1,1.94-1.78A3.05,3.05,0,0,1,18.21,13.8Z" /><polyline className="cls-mix2" points="4.06 20.68 4.06 4.46 23.15 4.46" /><polyline className="cls-mix2" points="0.5 16.72 0.5 0.5 19.59 0.5" /></g></g></svg> */}
            <span className="menuLinkText">{t("nav.featuredMixes")}</span>
          </Link>
        </li>
        <li className="menubar-li">
          <Link
            className={
              location.pathname.includes("sounds")
                ? "menuLink active"
                : "menuLink"
            }
            to={"/sounds"}
          >
            <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68.05 68.05"><g id="Layer_23"><path className="cls-5" fill="none" strokeWidth={'4.54px'} strokeLinejoin="round" strokeLinecap="round" stroke="#fff" d="m65.78,20.42l-45.37,13.61m45.37,16.9V11.9c0-6.45-5.86-11.07-11.68-9.22l-27.22,8.66c-3.84,1.22-6.47,4.97-6.47,9.22v36.15m45.37-5.78c0,5.01-4.06,9.07-9.07,9.07s-9.07-4.06-9.07-9.07,4.06-9.07,9.07-9.07,9.07,4.06,9.07,9.07Zm-45.37,5.78c0,5.01-4.06,9.07-9.07,9.07s-9.07-4.06-9.07-9.07,4.06-9.07,9.07-9.07,9.07,4.06,9.07,9.07Z" /></g></svg>
            {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.23 14.4"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path fill="none" strokeWidth={'4.54px'} strokeLinejoin="round" strokeLinecap="round" stroke="#fff" className="cls-1" d="M13.92,4.32,4.32,7.2m9.6,4.8V2.52A1.94,1.94,0,0,0,11.45.57L5.69,2.4A2,2,0,0,0,4.32,4.35V12m13.44,0a1.92,1.92,0,1,1-1.92-1.92A1.92,1.92,0,0,1,17.76,12ZM4.32,12A1.92,1.92,0,1,1,2.4,10.08,1.92,1.92,0,0,1,4.32,12Z" /></g></g></svg> */}
            {/* <svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 68.05 68.05"><g id="Layer_23"><path className="cls-1" d="m65.78,20.42l-45.37,13.61m45.37,16.9V11.9c0-6.45-5.86-11.07-11.68-9.22l-27.22,8.66c-3.84,1.22-6.47,4.97-6.47,9.22v36.15m45.37-5.78c0,5.01-4.06,9.07-9.07,9.07s-9.07-4.06-9.07-9.07,4.06-9.07,9.07-9.07,9.07,4.06,9.07,9.07Zm-45.37,5.78c0,5.01-4.06,9.07-9.07,9.07s-9.07-4.06-9.07-9.07,4.06-9.07,9.07-9.07,9.07,4.06,9.07,9.07Z"/></g></svg> */}
            <span className="menuLinkText">{t("nav.sounds")}</span>
          </Link>
        </li>
        <li className="menubar-li">
          <Link
            className={
              location.pathname.includes("relax-rest")
                ? "menuLink active"
                : "menuLink"
            }
            to={"/relax-rest"}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.23 16.32"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path className="cls-1" d="M14.88,3.36V13M12,5.28V11m5.76-5.76V11M.48,4.32V12M6.24.48V15.84M9.12,3.36V13M3.36,2.4V13.92" /></g></g></svg>
            <span className="menuLinkText">{t("nav.relaxRest")}</span>
          </Link>
        </li>
        <li className="menubar-li">
          <Link
            className={
              location.pathname.includes("stories")
                ? "menuLink active"
                : "menuLink"
            }
            to={"/stories"}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15.36 18.23"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path className="cls-1" d="M14.56,15.34a1,1,0,0,0-.47-1.71,8.76,8.76,0,0,1-5.9-3.8,9.2,9.2,0,0,1-.9-8A1,1,0,0,0,6,.56,9.11,9.11,0,0,0,.48,8.84c0,5,4.28,9,8.68,8.91A8.2,8.2,0,0,0,14.56,15.34Z" /></g></g></svg>
            <span className="menuLinkText">{t("nav.stories")}</span>
          </Link>
        </li>
        {
          !hideUrlForAge() ? '' : (
            <li className="menubar-li">
              <Link
                className={
                  location.pathname.includes("articles")
                    ? "menuLink active"
                    : "menuLink"
                }
                to={"/articles"}
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.15 17.19"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path className="cls-2" d="M1,.72A.32.32,0,0,0,.72,1V16.16a.33.33,0,0,0,.32.32H13.11a.33.33,0,0,0,.32-.32V1a.32.32,0,0,0-.32-.32ZM13.11,17.19H1a1,1,0,0,1-1-1V1A1,1,0,0,1,1,0H13.11a1,1,0,0,1,1,1V16.16a1,1,0,0,1-1,1" /><path className="cls-2" d="M2.43,6.11H6.86V3.42H2.43Zm4.47.72H2.38a.68.68,0,0,1-.67-.68V3.37a.67.67,0,0,1,.67-.67H6.9a.67.67,0,0,1,.68.67V6.15a.68.68,0,0,1-.68.68" /><path className="cls-2" d="M12.08,9.38H2.3A.36.36,0,0,1,1.94,9a.36.36,0,0,1,.36-.36h9.78a.36.36,0,0,1,.36.36.36.36,0,0,1-.36.36" /><path className="cls-2" d="M12.08,11.94H2.3a.36.36,0,1,1,0-.72h9.78a.36.36,0,0,1,0,.72" /><path className="cls-2" d="M12.08,14.5H2.3a.36.36,0,0,1,0-.72h9.78a.36.36,0,0,1,0,.72" /><path className="cls-2" d="M12.08,3.84h-3a.36.36,0,0,1-.36-.36.36.36,0,0,1,.36-.36h3a.36.36,0,0,1,.36.36.36.36,0,0,1-.36.36" /><path className="cls-2" d="M12.08,6.4h-3a.36.36,0,0,1,0-.72h3a.36.36,0,1,1,0,.72" /></g></g></svg>
                <span className="menuLinkText">{t("nav.avArticles")}</span>
              </Link>
            </li>
          )
        }
      </ul>
      <ul className="list-unstyled d-none d-md-block m-0">
        <li className="menubar-li">
          <Link
            className={
              location.pathname.includes("my-mixes")
                ? "menuLink active"
                : "menuLink"
            }
            to={"/my-mixes"}
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.29 25.31"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Sounds"><rect className="cls-mix1" x="7.63" y="8.63" width="21.16" height="16.18" /><path className="cls-mix2" d="M18.21,13.8a3,3,0,0,1,2.57-1.19,2.83,2.83,0,0,1,1.94,1.71c.69,1.68-.66,3.77-3.32,6.12a1.85,1.85,0,0,1-2.42,0c-2.65-2.35-4-4.41-3.28-6.08a2.88,2.88,0,0,1,1.94-1.78A3.05,3.05,0,0,1,18.21,13.8Z" /><polyline className="cls-mix2" points="4.06 20.68 4.06 4.46 23.15 4.46" /><polyline className="cls-mix2" points="0.5 16.72 0.5 0.5 19.59 0.5" /></g></g></svg>
            <span className="menuLinkText">{t("header.mixes")}</span>
          </Link>
        </li>
        {
          hideUrlForAge() && hideUrlForCountry(userCountry) && (
            <>
              <hr className="menuSeperator d-none d-md-block" />
              <li className="menubar-li">
                <Link
                  className="menuLink"
                  to={"https://scofa.com/articles/"}
                  target="_blank"
                >
                  <img src={ArticlesIcon} className="menuIcon" />
                  {/* <ArticlesIcon /> */}
                  {/* </span> */}
                  <span className="menuLinkText">{t("nav.articles")}</span>
                </Link>
              </li>
              <li className="menubar-li">
                <Link
                  className="menuLink"
                  to={"https://store.scofa.com/"}
                  target="_blank"
                >
                  {/* <span className="menuIcon">
              <StoreIcon />
            </span> */}
                  <img src={StoreIcon} className="menuIcon" />
                  <span className="menuLinkText">{t("nav.sleepStore")}</span>
                </Link>
              </li>
              <li className="menubar-li">
                <Link
                  className="menuLink"
                  to={"https://scofa.com/check-sleep-disorder-symptoms/"}
                  target="_blank"
                >
                  <img src={CheckSymptomsIcon} className="menuIcon" />
                  {/* <span className="menuIcon">
              <CheckSymptomsIcon />
            </span> */}
                  <span className="menuLinkText">{t("nav.checkSymptoms")}</span>
                </Link>
              </li>

              <li className="menubar-li">
                <Link className="menuLink" to={"https://scofa.com/search-for-sleep-provider/"} target="_blank">
                  {/* <span className="menuIcon">
              <FindDoctorsIcon />
            </span> */}
                  <img src={FindDoctorsIcon} className="menuIcon" />
                  <span className="menuLinkText">{t("nav.sleepDoctors")}</span>
                </Link>
              </li>
            </>
          )
        }
        <hr className="menuSeperator d-none d-md-block" />
        <li className="menubar-li">
          <QrCodeGenerator
            qrIsVisible={qrIsVisible}
            handleQrCode={(value) => {
              if (value) {
                setShowHideTray(false)
              }
              setQrIsVisible(value)
            }}
          />
        </li>
        {
          hideUrlForAge() &&  <li className="information-tray-card py-0">
          {loader ? <div className="skeleton"></div>
            : <div className={`information-tray-image ${showHideTray && 'show'}`} onClick={() => {
              if (!showHideTray) {
                setQrIsVisible(false)
              }
              setShowHideTray(!showHideTray)
            }}>
              <img src={desktopLogo} />
            </div>
          }
        </li>
        }
       
      </ul>
      {
        (window.innerWidth > 991) && (
          <div className={`information-tray d-flex flex-column ${showHideTray && 'show'}`}>
            <div className="header position-relative">
              <button
                className="closeButton notButton ms-auto d-flex p-3"
                onClick={() => { setShowHideTray(false) }}
              >
                <img src={crossIcon} alt="" />
              </button>
              <img src={headerLogo} className="w-100 info-header-image" />
            </div>
            <div className="scrollbar">
              <div className="p-3">
                <div className="information-tray-data w-100" ref={primaryInformation}></div>
              </div>
            </div>
          </div>
        )
      }

    </div>
  );
};

